import { React, useState, useEffect } from "react"
import Navbar from "./components/Navbar.js"
import About from "./components/About/About.js"
import Projects from "./components/Projects/Projects.js"
import Resume from "./components/Resume/Resume.js"
import Contact from "./components/Contact.js"
import Footer from "./components/Footer.js"
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Header from "./components/Header.js";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Pre from "./components/Pre.js"

function ScrollEffects() {
  const location = useLocation();

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal");
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) {
      elements.forEach((element) => element.classList.add("is-visible"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }
    );

    elements.forEach((element, index) => {
      element.style.setProperty("--reveal-delay", `${Math.min(index * 45, 260)}ms`);
      observer.observe(element);
    });

    return () => observer.disconnect();
  }, [location.pathname]);

  return null;
}

function App() {
  const [load, upadateLoad] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 900);

    return () => clearTimeout(timer);
  }, []);

 
  return (

    <Router>
      <ScrollEffects />
      <Pre load={load} />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Header />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/contacts" element={<Contact />} className="main-content" />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
